import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    findcoa(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`coa/findcoa/${obj.kodeacc}/${obj.tahun}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'postgrpcode', 'postgrpname', 'ApAccount'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/appostgrp${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}
,save(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("appostgrp", obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
,remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.delete(`appostgrp/${obj.postgrpcode}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'postgrpcode', 'postgrpname', 'ApAccount'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            let response = await axios({
                url: `/appostgrp/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `AP-Posting-Group.xlsx`);
            document.body.appendChild(link);
            link.click();
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
};